import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    jobs: [],
    modelDefault: {
        id: null,
        bot_id: null,
        category: null,
        subcategory: null,
        method: null,
        status: null,
        created_at: null,
        finished_at: null,
        errors: null,
        percent: 0
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}
